<div>
  <div class="modal-header">
    <h3>Select Application Type</h3>
  </div>
  <div class="modal-body">
    <div class="row" *ngIf="application_type !== 'renewal'" style="display: flex; justify-content: space-around">
      <div class="col-xs-12 col-sm-3 col-sm-offset-3 text-center" style="padding-bottom: 10px;">
        <button class="btn btn-default" (click)="close({type: 'new'})">New Application</button>
      </div>
      <div class="col-xs-12 col-sm-3 text-center">
        <button class="btn btn-default" (click)="close({type: 'renewal'})">Renewal Application</button>
      </div>
    </div>
<!--    <div class="row" *ngIf="application_type === 'renewal'">-->
<!--      <div class="col-xs-12">-->
<!--        If available please provide previous permit number; otherwise, click continue to proceed.-->
<!--      </div>-->
<!--      <div class="col-xs-12 col-sm-5">-->
<!--        <label class="control-label">Previous Permit Number</label>-->
<!--      </div>-->
<!--      <div class="col-xs-10 col-sm-5 text-center" style="padding-bottom: 10px; padding-right:0;">-->
<!--        <input class="form-control" [ngModel]="old_permit_number"/>-->
<!--      </div>-->
<!--      <div class="col-xs-1 text-center" style="padding-left:0">-->
<!--        <button class="btn btn-default" (click)="close({type: 'renewal', 'old_permit_number': old_permit_number})">-->
<!--          Continue-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->
  </div>
  <div class="modal-footer">
  </div>
</div>
